import { actions } from "../actions/types";
import { figuritas } from "../data";

const initialState = {
  figuritas: null,
  albumsAutorizados: [],
  miAlbum: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.UPDATE_FIGURITAS:
      return {
        ...state,
        figuritas: action.payload,
      };
    case actions.ALBUMS_AUTORIZADOS:
      return {
        ...state,
        albumsAutorizados: action.payload,
      };
    case actions.MI_ALBUM:
      return {
        ...state,
        miAlbum: action.payload,
      };

    default:
      return state;
  }
}
